import { Controller, Post, Req } from '@nestjs/common';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { AllGradeSuggestionResponse, GradeSequenceModel, GradeSuggestionResponse} from '@gtpl/shared-models/masters';
import { Body, Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Raw, Repository } from 'typeorm';
import { GradeSuggestionAdapter } from './dto/grade-suggestion.adapter';
import { GradeSuggestionDTO } from './dto/grade-suggestion.dto';
import { GradeSuggestion } from './grade-suggestion.entity';
import { LogActions, LoggerInstantiation } from 'apps/services/logger/logger-functions';
import { GradeSuggestionRequest } from './dto/grade-suggestion.request';
import { GradeSuggestionService } from './grade-suggestion.service';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { CommonResponse } from '@gtpl/shared-models/production-management';
import { Cron } from '@nestjs/schedule';


@Controller('grade-suggestion')
export class GradeSuggestionController {
    constructor(
        private GradeSuggestionService: GradeSuggestionService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
      ) {}
    
    
       /**
         * creates or updates a GradeSuggestion
         * @param GradeSuggestion GradeSuggestion DTO
         * @returns GradeSuggestionResponse
         */
        @Post('/createGradeSuggestion')
        async createGradeSuggestion(@Body() gradeSuggestionsDto:GradeSuggestionDTO,isUpdate:boolean=false,@Req() request:Request): Promise<GradeSuggestionResponse> {
            try {
             return await this.GradeSuggestionService.createGradeSuggestion(gradeSuggestionsDto,false,request);
           } catch (error) {
                return this.applicationExceptionHandler.returnException(GradeSuggestionResponse, error);
           }
         }
    
         /**
         * gets all the Food Types
         * @returns AllGradeSuggestionsResponseModel which returns all the Food Types  along with status (true/false), errortype, errorCode, internal message which provides message to the calling function.
         */
    
        @Post('/getAllGradeSuggestions')
        async getAllGradeSuggestions(): Promise<AllGradeSuggestionResponse> {
            try {
                return await this.GradeSuggestionService.getAllGradeSuggestions();
            } catch (error) {
                return this.applicationExceptionHandler.returnException(AllGradeSuggestionResponse, error);
            }
        }
        @Post('/getAllActiveGradeSuggestions')
      async getAllActiveGradeSuggestions(@Req() request: Request): Promise<AllGradeSuggestionResponse> {
          try {
              return await this.GradeSuggestionService.getAllActiveGradeSuggestions();
          } catch (error) {
              return this.applicationExceptionHandler.returnException(AllGradeSuggestionResponse, error)
          }
      }
    
         /**
         * Activate Or De-Activate Food Type
         * @param getSingleGradeSuggestion 
         * @returns GradeSuggestionResponse
         */
       @Post('/activateOrDeactivateGradeSuggestion')
       async activateOrDeactivateGradeSuggestion(@Body() gradeSuggestionRequest: GradeSuggestionRequest): Promise<GradeSuggestionResponse> {
           try {
               return await this.GradeSuggestionService.activateOrDeactivateGradeSuggestion(gradeSuggestionRequest);
           } catch (err) {
               console.log(err);
               return this.applicationExceptionHandler.returnException(GradeSuggestionResponse, err);
           }
       }
    
       /**
         * creates or updates a GradeSuggestion
         * @param GradeSuggestion GradeSuggestion DTO
         * @returns GradeSuggestionResponse
         */
        @Post('/updateGradeSuggestion')
        async updateGradeSuggestion(@Body() @Req() request:GradeSequenceModel[]): Promise<CommonResponse> {
            try {
             return await this.GradeSuggestionService.updateGradeSuggestion(request);
           } catch (error) {
                return this.applicationExceptionHandler.returnException(CommonResponse, error);
           }
         }
         @Post('/getGradeSuggestionDataById')
        async getGradeSuggestionDataById(@Body() gradeSuggestionRequest:GradeSuggestionRequest,@Req() request: Request): Promise<GradeSuggestionResponse> {
            try {
            return await this.GradeSuggestionService.getGradeSuggestionDataById(gradeSuggestionRequest);
            } catch (error) {
                return this.applicationExceptionHandler.returnException(GradeSuggestionResponse, error)
            }
        }
      
       
        @Post('/insertData')
        async insertData() {
            try {
              return await this.GradeSuggestionService.insertData();
            }catch (error) {
                return this.applicationExceptionHandler.returnException(CommonResponse, error)
            }
        }

    
    
}
